import '../styles/main.scss';
import { initInputs } from '@components/inputs';
import { initAccordions } from '@components/accordions';
import { initModals } from '@components/modals';
import { initVideoControls } from '@components/media';

(() => {
  initInputs();
  initAccordions();
  initModals();
  initVideoControls();
})();
